import {KTIcon} from '../../../_metronic/helpers'
import {Billing} from '../core/_models'
import {formatDateTime} from '../../../utils/dayJs/format'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'
import {CreditCardRefundStatus} from './CreditCardRefundStatus'

interface IBilling {
  billing: Billing
  close: () => void
}

const BillingShowHistoryModal = ({billing, close}: IBilling) => {
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_edit_status'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-800px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>Histórico do faturamento: </h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={() => close()}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='row mb-6 mt-4'>
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 gy-7'>
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='min-w-120px'>Dt Processamento</th>
                        <th className='min-w-120px'>Usuário</th>
                        <th className='min-w-120px'>Status</th>
                        <th className='min-w-120px'>Observação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {billing.history.map((history) => (
                        <tr key={`billingShowHistoryColun${history.id}`}>
                          <td>{formatDateTime(history.createdAt)}</td>
                          <td>{history.user.name}</td>
                          <td>{history.status}</td>
                          <td>{history.observation}</td>
                        </tr>
                      ))}
                      {billing?.paymentOption?.id === 4 &&
                        billing.creditCardRefunds?.map((refund) => (
                          <tr key={`creditCardRefund${refund.id}`}>
                            <td colSpan={4}>
                              <b>Estorno Cielo: Valor de {formatMonetaryToBr(refund.amount)}</b>
                              <CreditCardRefundStatus
                                refund={refund}
                                onUpdated={() => window.location.reload()}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {BillingShowHistoryModal}
